export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7296.a183c1e7.jpg";